import common from './en/common';
import auth from './en/auth';
import navigation from './en/navigation';
import profile from './en/profile';
import integrations from './en/integrations';
import agents from './en/agents';
import skills from './en/skills';
import jobs from './en/jobs';
import dashboards from './en/dashboards';
import settings from './en/settings';
import { subscription } from './en/subscription';
import dataSources from './en/dataSources';
import playground from './en/playground';
import knowledge from './en/knowledge';
import memory from './en/memory';
import workflow from './en/workflow';
import register from './en/register';
import resetPassword from './en/resetPassword';
import recoverPassword from './en/recoverPassword';
import logs from './en/logs';
import users from './en/users';
import installation from './en/installation';
import dynamicParameterFields from './en/ui/dynamic-parameter-fields';
import tour from './en/tour';
import workspaces from './en/workspaces';
import communicator from './en/communicator';
import assistant from './en/assistant';
import products from './en/products';
import facets from './en/facets';
import errors from './en/errors';
import notifications from './en/notifications';

const translations = {
  common,
  errors,
  auth,
  navigation,
  profile,
  integrations,
  agents,
  skills,
  jobs,
  dashboards,
  settings,
  subscription,
  dataSources,
  playground,
  knowledge,
  memory,
  workflow,
  register,
  resetPassword,
  recoverPassword,
  logs,
  users,
  installation,
  dynamicParameterFields,
  tour,
  workspaces,
  communicator,
  assistant,
  products,
  facets,
  notifications,
} as const;

export default translations;
